import { PayloadAction } from '@reduxjs/toolkit';

import { ConversationStatus, ConversationStatuses } from '../../../api/messaging/types';
import { MessagingSlice } from './types';

const updateActiveExpertConversationId = (
    state: MessagingSlice,
    action: PayloadAction<{ conversationId?: string }>
) => {
    state.activeConversationId = action.payload.conversationId;
};

const updateConversationStatus = (state: MessagingSlice, action: PayloadAction<{ status: ConversationStatus }>) => {
    const status = action.payload.status;
    const index = state.conversations.conversationStatuses.findIndex(
        (convo: ConversationStatus) => convo.conversationId === status.conversationId
    );
    if (index > -1) {
        state.conversations.conversationStatuses[index] = status;
    } else {
        state.conversations.conversationStatuses.push(status);
    }
};

const updateConversationStatuses = (
    state: MessagingSlice,
    action: PayloadAction<{ statuses: ConversationStatuses }>
) => {
    const existingConversationStatuses: ConversationStatus[] = [...state.conversations.conversationStatuses];
    const { conversationStatuses } = action.payload.statuses;

    conversationStatuses.forEach((newStatus) => {
        const existingStatusIndex = existingConversationStatuses.findIndex(
            (existingStatus) => existingStatus.conversationId === newStatus.conversationId
        );
        if (existingStatusIndex > -1) {
            const existingStatus = existingConversationStatuses[existingStatusIndex];
            if (existingStatus.latestMessageTimestamp < newStatus.latestMessageTimestamp) {
                existingConversationStatuses[existingStatusIndex] = newStatus;
            }
        } else {
            existingConversationStatuses.push(newStatus);
        }
    });

    state.conversations = {
        forEventsAfterTimestamp: action.payload.statuses.forEventsAfterTimestamp,
        forEventsUntilTimestamp: action.payload.statuses.forEventsUntilTimestamp,
        latestEventTimestamp: action.payload.statuses.latestEventTimestamp,
        earliestEventTimestamp: action.payload.statuses.earliestEventTimestamp,
        conversationStatuses: existingConversationStatuses,
    };

    state.haveUnreadMessages = false;
};

const updateLatestConversationEventTimestamp = (
    state: MessagingSlice,
    action: PayloadAction<{ lastEventTimestamp: string }>
) => {
    if (state.conversations.forEventsUntilTimestamp < action.payload.lastEventTimestamp) {
        state.haveUnreadMessages = true;
    } else {
        state.haveUnreadMessages = false;
    }
};

const updateHaveUnreadMessages = (state: MessagingSlice, action: PayloadAction<{ value: boolean }>) => {
    state.haveUnreadMessages = action.payload.value;
};

const chatReducer = {
    updateActiveExpertConversationId,
    updateConversationStatus,
    updateConversationStatuses,
    updateLatestConversationEventTimestamp,
    updateHaveUnreadMessages,
};

export default chatReducer;
